export interface CourseAccessData {
  hasAccess: boolean
  isAccessExpired?: boolean
}

export interface BasicProductInfo {
  id: string
  title: string
  description: string
  locationId: string
}

export const coursesAccessGuardQueryKeys = {
  productAccess: (courseId: string, locationId: string, source: string) =>
    ['courses-access-guard', 'product-access', locationId, courseId, source] as const,
  basicProductInfo: (courseId: string, locationId: string) => ['courses-access-guard', 'basic-product-info', locationId, courseId] as const,
}

export async function fetchCourseAccessData(params: {
  courseId: string
  locationId: string
  source: string
}): Promise<CourseAccessData | null> {
  try {
    const { ProductLearnerService } = await import('@courses/product-theme-layer/services/product-learner.service')
    const service = new ProductLearnerService()

    return (await service.checkProductAccess({
      courseId: params.courseId,
      locationId: params.locationId,
      source: params.source,
    })) as CourseAccessData
  } catch (error) {
    console.error('❌ [Courses Access Guard Service] Failed to fetch course access data:', error)
    throw error
  }
}

export async function fetchBasicProductInfo(params: { courseId: string; locationId: string }): Promise<BasicProductInfo | null> {
  try {
    const { ProductLearnerService } = await import('@courses/product-theme-layer/services/product-learner.service')
    const service = new ProductLearnerService()
    return (await service.getBasicProductInfo({
      courseId: params.courseId,
      locationId: params.locationId,
    })) as BasicProductInfo
  } catch (error) {
    console.error('❌ [Courses Access Guard Service] Failed to fetch basic product info:', error)
    throw error
  }
}
